export default __webpack_public_path__ + "static/media/Frame_186.1588847e.jpg";